export const stripConstants = {
    text: 'If you would like one of our sales representatives to call you.',
    buttonText: 'Contact Us'
}